import React from 'react';
import Plan from '../nv.pdf'

const BusinessPlan = () => (
  <div className='business-plan-div' id='business-plan-div'>
    <a
      href={Plan}
      target="_blank"
      rel="noopener noreferrer"
      className='business-plan-link'
    >
      📄 Click to View Business Plan <i className="fas fa-arrow-right"></i>
    </a>
  </div>
);

export default BusinessPlan;